export default {
  login: {
    title: 'マイページログイン',
    double_check_text: '入力された情報は正しくありません、再度確認をお願いします。',
    id_email: 'ID/メールアドレス',
    password: 'パスワード',
    password_display: 'パスワードを表示',
    password_no_display: 'パスワードを未表示',
    login: 'ログイン',
    keep_login_text: 'ログイン情報を保持する',
    forgot_password_text: 'パスワードをお忘れの方はこちら',
    contact_us: '未登録の方はお問い合わせから',
    asuene_service_outline: 'CO2見える化クラウドサービス「アスエネ」',
    asuene_lca_service_outline: 'CFP/LCA算定サービス「アスエネLCA」',
    asuene_career_service_outline: 'GX・ESG人材特化型転職プラットフォーム「アスエネキャリア」',
    corporate_page: '企業HP',
    cross_use: {
      title: 'アスエネの脱炭素・ESG\nワンストップソリューション',
      asuene_product: {
        banner_title: 'AI搭載のCO2見える化・削減・報告クラウド',
        flag_text: '累計導入社数<span class="caution">※</span><br /><strong><small>No.</small>1</strong>',
        left_btn_label: '無料デモ',
        left_btn_link: 'https://asuene.com/form/free-demo',
        right_btn_label: '資料ダウンロード',
        right_btn_link: 'https://asuene.com/form/download/asuene',
      },
      footer_note: '※東京商工リサーチ調べ/2024年7月調査時点。',
    },
  },
}
